import { fork } from 'redux-saga/effects'

import * as watchers from './cropper-watchers'

export default [
  fork(watchers.watchCropperSelect),
]



/** WEBPACK FOOTER **
 ** ./src/sagas/cropper/index.js
 **/